import { webEnv as env } from "@revana/env";

import { getProductionUrl } from "./constants";

const getCookieDomain = () => {
  const VERCEL_ENV =
    typeof window === "undefined" ? env.VERCEL_ENV : env.NEXT_PUBLIC_VERCEL_ENV;

  if (VERCEL_ENV === "development") {
    return "localhost";
  }

  const url = new URL(getProductionUrl());

  return `.${url.hostname.split(".").slice(-2).join(".")}`;
};

export default getCookieDomain;
